'use strict';

var LS_KEY = 'owl_cache';
var isSupport = require('./ls');
var Logger = require('./logger');

/**
 * 错误LocalStorage存储
 */
module.exports = {
    isSupport: isSupport(),
    get: function get() {
        if (!this.isSupport) return;
        var cache = [];
        try {
            var cacheStr = localStorage.getItem(LS_KEY);
            if (cacheStr) {
                cache = JSON.parse(cacheStr);
            }
        } catch (e) {
            Logger.ignore(e);
        }
        return cache;
    },
    add: function add(nextCache) {
        if (!this.isSupport) return;
        if (nextCache instanceof Array) {
            var preCache = this.get();
            nextCache = nextCache.concat(preCache);
            try {
                localStorage.setItem(LS_KEY, JSON.stringify(nextCache));
            } catch (e) {
                Logger.ignore(e);
            }
        }
    },
    clear: function clear() {
        if (!this.isSupport) return;
        try {
            localStorage.removeItem(LS_KEY);
        } catch (e) {
            Logger.ignore(e);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/db.js
// module id = 256
// module chunks = 0